import cn from 'classnames';
import React from 'react';
import { Icon } from 'src/components/icon';
import { ShadowView } from 'src/components/shadow-view';

import { ReactComponent as TabbyBadge } from './assets/tabby-badge.svg';
import { ReactComponent as TabbyWordmarkBlack } from './assets/tabby-wordmark-black.svg';
import { ReactComponent as TabbyWordmarkWhite } from './assets/tabby-wordmark-white.svg';
import styles from './styles.css';
import { type LogoProps } from './types';

/**
 * @link https://www.figma.com/file/uKBCGBTDE2yHJDFaB2I0k8/Branding?node-id=2%3A367
 */
export const Logo = ({
  className,
  color = 'black on green',
  ...props
}: LogoProps) => {
  const classes = cn(styles.tabbyInfoLogo, className);

  const getLogoComponent = () => {
    switch (color) {
      case 'black on green':
        return <TabbyBadge {...props} className={classes} />;
      case 'black on transparent':
        return <TabbyWordmarkBlack {...props} className={classes} />;
      case 'white on transparent':
        return <TabbyWordmarkWhite {...props} className={classes} />;
      case 'ramadan':
        return (
          <div className={cn(styles.ramadan)}>
            <TabbyBadge {...props} className={classes} />
            <Icon name="ramadan" />
          </div>
        );

      default:
        throw new Error('Not implemented');
    }
  };

  return <ShadowView shouldInheritColor>{getLogoComponent()}</ShadowView>;
};
